import type { RouteObject } from "react-router-dom";
import { PrivacyPage } from "@/pages/PrivacyPage";
import { TermsPage } from "@/pages/TermsPage";

export const legalRoutes = [
  {
    path: "terms",
    element: <TermsPage />,
  },
  {
    path: "privacy",
    element: <PrivacyPage />,
  },
] satisfies RouteObject[];
